import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { DocumentService } from '@app/shared/services';
import { Observable, Subscription, fromEvent } from 'rxjs';
import { ManageAssociatedFormComponent } from './manage-associated-form/manage-associated-form.component';
import { VaultStoreEffects } from '@app/root-store/vault-store/effects';
import { UntypedFormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { ManageAssociatedOtherFormComponent } from './manage-associated-other-form/manage-associated-other-form.component';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'stepper-manage-contact-list',
  templateUrl: './stepper-manage-contact-list.component.html',
  styleUrls: ['./stepper-manage-contact-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepperManageContactListComponent implements OnInit, OnDestroy {
  @ViewChild(ManageAssociatedFormComponent) manageAssociatedForm: ManageAssociatedFormComponent;
  @ViewChild(ManageAssociatedOtherFormComponent) manageAssociatedOtherForm: ManageAssociatedOtherFormComponent;
  subscription: Subscription = new Subscription();
  @Output('parentFun') parentFun: EventEmitter<any> = new EventEmitter<any>();
  resizeObservable$: Observable<Event>;
  @Input() securityStateObject;
  @Input() currentuserId;
  @Input() parent_vault_user_form_id;
  @Input() data;
  @Input() manageType = 'contact';
  @Input() is_mx_btn_needed = false;
  @Input() stepperType = '';
  screenWidth: number;
  associationForm = new UntypedFormControl();
  is_loading = true;
  associate_form_list = [];
  action_type_config_list = [];
  full_list = [];
  forms = [];

  currentStep = 0;
  isOtherEnable = false;
  noMatchFound;
  full_searchList = [];
  searchList;

  searchText;
  constructor(private cd: ChangeDetectorRef, private vaultService: VaultStoreEffects, private documentService: DocumentService) {}
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  movetonext(status) {
    this.parentFun.emit({ status });
  }
  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.subscription.add(
      this.resizeObservable$.subscribe((evt) => {
        this.screenWidth = evt.target['innerWidth'];
      })
    );

    let action_type_config_list = [];
    try {
      action_type_config_list = JSON.parse(this.data.action_type_config);
    } catch (error) {}

    this.subscription.add(
      this.vaultService.vaultObject.subscribe((state) => {
        this.forms = state.forms;
      })
    );
    let stepper_list = this.forms.find((x) => x.id == this.data.vault_form_id);
    this.createStepperList(this.stepperType);
    try {
      this.isOtherEnable = this.action_type_config_list[this.currentStep].description.toLowerCase().indexOf('other') == -1 ? false : true;
    } catch (error) {}

    this.getAssociateFormList();
    this.searchFileList();
    this.subscription.add(
      this.associationForm.valueChanges
        .pipe(
          startWith(''),
          map((value) => this.filter(value))
        )
        .subscribe((response) => {
          if (response.length == 0 && this.searchText) {
            this.noMatchFound = true;
          } else {
            this.noMatchFound = false;
          }
          this.searchList = response;
          this.cd.detectChanges();
        })
    );
    this.resetCheckbox();
  }
  createStepperList(type) {
    try {
      let stepper_list = this.forms.find((x) => x.id == this.data.vault_form_id);
      let linked_passwords = stepper_list[type]?.split(',');
      this.action_type_config_list = linked_passwords.map((x) => {
        if (x.indexOf('#') >= 0) {
          let description = x.slice(0, x.indexOf('#'));
          let list = x.slice(x.indexOf('#') + 1, x.length - 1);
          return {
            list: list.split(';'),
            description: description.trim(),
            status: 'Start',
          };
        } else {
          return {
            list: [],
            description: x.trim(),
            status: 'Start',
          };
        }
      });
    } catch (error) {}
  }
  resetCheckbox() {
    if (this.data.status == 'complete') {
      try {
        this.manageAssociatedOtherForm.selectDOntAdd = true;
      } catch (error) {}
      try {
        this.manageAssociatedForm.selectDOntAdd = true;
      } catch (error) {}
    }
    this.cd.detectChanges();
  }
  private filter(value) {
    let current_template = this.forms.find((x) => x.type == this.action_type_config_list[this.currentStep].description);
    this.associate_form_list = this.full_list.filter((x) => x.vault_form_id == current_template.id);

    let searchList = this.full_searchList.filter((x) => x.vault_form_id == current_template.id);
    if (searchList && value?.toLowerCase().length && value.length != 0) {
      this.searchText = true;
      return searchList.filter(
        (user) => user?.form_name?.toLowerCase().includes(value?.toLowerCase()) || user?.name?.toLowerCase().includes(value?.toLowerCase())
      );
    } else {
      this.searchText = false;
      return searchList;
    }
  }
  selectAssociatedUser($event, data) {
    let payload = {
      user_id: +this.currentuserId,
      vault_user_form_id: this.data.vault_user_form_id,
      created_by_user_id: this.currentuserId,
      association_type: this.manageType,
      source: 'onboarding',
      associate_vault_user_form_id: data.id,
    };

    this.subscription.add(
      this.documentService.createUserFormAssociation(payload).subscribe((result) => {
        // refresh modal
        this.getAssociateFormList();
        this.searchFileList();
        this.cd.markForCheck();
      })
    );
  }
  searchFileList() {
    this.subscription.add(
      this.documentService.getFormUserFormAssociation(this.currentuserId, this.data?.vault_user_form_id).subscribe(
        (res) => {
          if (res) {
            this.full_searchList = res;
            this.filterList();
            this.cd.detectChanges();
          }
        },
        (error: any) => {}
      )
    );
  }
  getAssociateFormList() {
    this.is_loading = true;
    this.associate_form_list = [];
    this.subscription.add(
      this.documentService.getUserFormAssociation(this.data.user_id, this.data.vault_user_form_id).subscribe((res) => {
        this.is_loading = false;
        this.full_list = res;

        this.searchFileList();
        this.filterList();
        this.cd.detectChanges();
      })
    );
  }
  filterList() {
    if (this.action_type_config_list[this.currentStep].list.length) {
      let ids = [];
      this.action_type_config_list[this.currentStep].list.forEach((element) => {
        let findIndex = this.forms.findIndex((x) => x.type?.toLowerCase().indexOf(element.toLowerCase()) >= 0);
        if (findIndex >= 0) {
          ids.push(this.forms[findIndex].id);
        }
      });
      this.associate_form_list = [];
      this.searchList = [];

      this.full_list.forEach((element, index) => {
        if (ids.findIndex((x) => x == element.vault_form_id) >= 0) {
          this.associate_form_list.push(element);
        }
      });
      this.full_searchList.forEach((element, index) => {
        if (ids.findIndex((x) => x == element.vault_form_id) >= 0) {
          this.searchList.push(element);
        }
      });
    } else {
      try {
        this.isOtherEnable = this.action_type_config_list[this.currentStep].description.toLowerCase().indexOf('other') == -1 ? false : true;
      } catch (error) {}

      if (this.isOtherEnable) {
        let ids = [];
        this.action_type_config_list.forEach((element, index) => {
          if (index != this.currentStep) {
            let current_template = this.forms.find((x) => x.type == this.action_type_config_list[index].description);
            ids.push(current_template.id);
          }
        });
        this.associate_form_list = [];
        this.searchList = [];

        this.full_list.forEach((element, index) => {
          if (
            ids.findIndex((x) => x == element.vault_form_id) == -1 &&
            element?.template_is?.toLowerCase().indexOf(this.manageType.toLowerCase()) >= 0
          ) {
            this.associate_form_list.push(element);
          }
        });
        this.full_searchList.forEach((element, index) => {
          if (
            ids.findIndex((x) => x == element.vault_form_id) == -1 &&
            element?.template_is?.toLowerCase().indexOf(this.manageType.toLowerCase()) >= 0
          ) {
            this.searchList.push(element);
          }
        });
      } else {
        let current_template = this.forms.find((x) => x.type == this.action_type_config_list[this.currentStep].description);
        this.associate_form_list = this.full_list.filter((x) => x.vault_form_id == current_template.id);

        this.searchList = this.full_searchList.filter((x) => x.vault_form_id == current_template.id);
      }
    }
    this.cd.detectChanges();
  }

  getUpdatedData() {
    this.getAssociateFormList();
  }
  previousContact() {
    if (this.currentStep == 0) {
    } else {
      this.currentStep = this.currentStep - 1;
      if (this.currentStep >= this.action_type_config_list.length) {
        this.currentStep = this.action_type_config_list.length - 1;
      }
    }
    this.filterList();
    this.resetCheckbox();
    this.cd.detectChanges();
  }
  nextContact() {
    this.currentStep = this.currentStep + 1;
    this.filterList();
    this.resetCheckbox();
    this.cd.detectChanges();
  }
}
